<template>
    <b-modal
        v-model="show"
        centered
        :title="title"
        lazy
    >
        <!-- Supplier -->
        <b-form-group
            label="Venue"
            label-cols="4"
        >
            <AccountSearchSelect
                v-model="account"
                placeholder="Search for a venue..."
                tag-placeholder="Create venue..."
            />
        </b-form-group>

        <b-form-group
            label="Status"
            label-cols="4"
        >
            <Multiselect
                ref="select"
                v-model="status"
                placeholder="Select a status..."
                :options="statuses"
                :multiple="false"
            />
        </b-form-group>

        <b-form-group
            label="Amount"
            label-cols="4"
        >
            <b-form-input
                v-model="amount"
            />
        </b-form-group>

        <b-form-group
            label="Notes"
            label-cols="4"
        >
            <b-form-textarea
                v-model="notes"
            />
        </b-form-group>

        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="reset"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                @click="submit"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
import { sync, get, call } from 'vuex-pathify';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Multiselect,
    },
    props: {
        title: {
            type: String,
            default: 'Add venue',
        },
    },
    computed: {
        ...sync('venues', [
            'venue@account',
            'venue@notes',
            'venue@status',
            'venue@amount',
        ]),
        show: sync('venues/showAddModal'),
        statuses: get('venues/statuses'),
    },
    methods: {
        reset: call('venues/resetModal'),
        submit: call('venues/saveVenue'),
    },
};
</script>

<style scoped>

</style>
